import { render, staticRenderFns } from "./MspForsageOrdersItemDate.vue?vue&type=template&id=6796a074&scoped=true&"
import script from "./MspForsageOrdersItemDate.vue?vue&type=script&lang=js&"
export * from "./MspForsageOrdersItemDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6796a074",
  null
  
)

export default component.exports